<template>
  <card>
    <div class="card-container margin-top-ml margin-bottom-ml">
      <img
        class="image-container"
        :src="inviteFriendsImage"
      >
      <div class="headline ri-bold-title margin-top-ml">
        יש לך עוד חברים שיכולים להרוויח מהאתגר?
      </div>
      <riseup-button
        title="הזמנת חברים לאתגר"
        size="slim"
        :action="shareClick"
        class="margin-top-ml"
      />
    </div>
  </card>
</template>

<script lang="ts" setup>

import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { storeToRefs } from 'pinia';
import inviteFriendsImage from '../../assets/invite-friends.svg';
import ShareUtils from '../../utils/share';
import { useChallengeStore } from '../../stores/challenge';
import config from '../../config';
import Segment from '../../Segment';

const MESSAGE_TEXT = 'נרשמתי לאתגר קהילתי של רייזאפ והוא פתוח לכולם ולכולן, רוצה להצטרף אלי? זה בחינם!';

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);
const CHALLENGE_URL = `${config.get().challengesFeUrl}/challenges/${challenge.value.challengeId}`;
const shareClick = async () => {
  Segment.trackUserInteraction('InviteFriendsCard_Clicked', {
    challengeId: challenge.value.challengeId,
  });

  await ShareUtils.shareLink(
    CHALLENGE_URL,
    MESSAGE_TEXT,
    {
      shareName: 'inviteFriendsLink',
      challengeId: challenge.value.challengeId,
    },
  );
};

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .image-container {
    width: 48px;
    height: 48px;
  }

  .headline {
    white-space: pre-wrap;
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  .description {
    text-align: center;
  }
}

</style>
